import { ClientModule, RootState } from '../redux';
import { DispatchProp, connect } from 'react-redux';
import Header, { HeaderProps } from '../components/UI/header_with_search_select/header';
import React, { PureComponent } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { SortTableRowInfo } from '../components/UI/table/sort_table';

import InfoIcon from '../assets/icons/InfoGrey.svg';
import { Bind } from 'lodash-decorators';
import { ClientContainer } from './client_shadcn';
import ClientModal from '../containers/client/client_modal';
import { ContentSection } from '../components/content/content_section';
import { PageContent } from '../components/content/page_content';
import { createCrispProfile, getCrispProfile } from '../api/crisp';
import { Crisp } from 'crisp-sdk-web';
import { checkIsBilling } from '../api/stripe';
import { ConfirmationModal } from '../modals/confirmation_modal';
import Select from '../ui_components/select/select';
import {
  Modal,
  ModalContent,
  ModalHeader as ModalHeaderE,
  ModalActions as ModalActionsE,
} from '../ui_components/modal';

import Tooltip from 'rc-tooltip';
import { BasicClientInfo } from '../redux/modules/client';
import { getAccount, updateAccount } from '../api/account';
import { getAllClients, getClientApi, searchClients } from '../api/client';
import { trackView } from '../components/analytics/track_view';
import { MixpanelEvents } from '../components/analytics/mix_panel_events';
import { ClientsTable } from '../components/UI/table/clients_table';
import styled from '../theme';
import { fetchQBOCustomers, importQBOClients } from '../api/quickbooks';
import { FadeLoader } from 'react-spinners';
import SuccessModal from '../modals/success-modal';
import Button from '../ui_components/button/button';
import Checkbox from '../ui_components/checkbox/checkbox';
import { handleUpdateLastViewedProject } from "../helper/apiFunctions";
import { readCachedPricingPermission } from '../helper/pricingPermission';
import { ScrollToPosition } from "../containers/application";
// tslint:disable-next-line:no-empty-interface
interface ClientOwnProps extends RouteComponentProps {
  isConnected?: boolean;
}

interface ClientsProps extends ClientOwnProps {
  accountId: number;
  email: string;
  firstName: string;
  lastName: string;

  // customers: QuickbooksCustomer[];
}

interface ClientsModalProps extends ClientOwnProps {
  isOpenModal: boolean;
  handleCloseModal(): void;
  handleOpenSubscriptionPlanModal(): void;
  handleShowBottomSheet(val: boolean, client?: any): void;
  handlePreFill?(payload: any): void;
  handleOpenSinglePurchasedGoods?(val: number | null): void;
  purchasedGoodsRefetch?: boolean;
  accountUser?: any
  canAccessTeamSettings?: boolean
  handleUpdateTeamMembers?(items: any[]): void
  backToTop?: boolean;
  pageScrollTo?(position: ScrollToPosition, val: number): void;
}

export type DotMenuState = {
  rowId: number;
  active: boolean;
};

interface State {
  isAddClientModalOpen: boolean;
  includeInactive: boolean;
  sort: { column: string; value: 'ASC' | 'DESC' };
  clients: SortTableRowInfo[];
  scrollTop?: number;
  isPopUpChecked: boolean;
  isPopModalRequired: boolean;
  isPopUpModalOpen: boolean;
  showModal: string | null;
  isLoading?: boolean;
  dotMenu: DotMenuState;
  client: any;
  addSubClient: boolean;
  openDropdown: boolean;
  spinner: boolean;
  selectedCustomerIds: Set<string>;
  customers: QuickbooksCustomer[];
  billingTypeSelections: Record<string, BillingTypeOption>;
  billToSelections: Record<string, BillToOption>;
  isClientReviewModalVisible: boolean;
  customersLoading: boolean;
  showSuccessModal: boolean;
  accountCanSeePricing: boolean;
  customerFetchError?: string | null;

  // NEW: parent/children maps for hierarchy enforcement
  parentById: Record<string, string | null>;
  childrenById: Record<string, string[]>;
}
type BillingTypeOption = 'Retail' | 'Trade';
type BillToOption = 'Self' | 'Parent';

interface QuickbooksCustomer {
  Id?: string | number;
  DisplayName?: string;
  ParentRef?: { value?: string; name?: string };
  Job?: boolean;
  Level?: number;
  Taxable?: boolean;
  BillWithParent?: boolean | null;
}

const BILLING_TYPE_OPTIONS: BillingTypeOption[] = ['Trade', 'Retail'];
const BILL_TO_OPTIONS: BillToOption[] = ['Self', 'Parent'];

const DuplicateSpinner = styled.div`
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 9999 !important;
`;

const ReviewModal = styled(Modal)`
  max-width: 960px !important;
  width: 90% !important;
  border-radius: 16px !important;
  border: 1px solid #e3ece7 !important;
`;

const ReviewModalHeader = styled(ModalHeaderE)`
  border-bottom: none !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  padding-bottom: 0 !important;
  color: #1f3c2e !important;
`;

const ReviewModalContent = styled(ModalContent)`
  display: flex !important;
  flex-direction: column !important;
  gap: 20px !important;
  padding-top: 0 !important;
  height: 70vh;
`;

const ReviewSummaryHeading = styled.div`
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #1f3c2e !important;
`;

const ReviewTable = styled.div`
  border: 1px solid #ddebe2 !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  height: 600px !important;
  overflow-y: auto !important;
`;

const ReviewTableHeader = styled.div`
  display: grid !important;
  /* allow shrinking with minmax(0, …) */
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1.5fr) !important;
  background: #ffffff !important;
  color: #1f3c2e !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  padding: 12px 20px !important;
`;

const ReviewTableRow = styled.div<{ $isSelected?: boolean; $isDisabled?: boolean }>`
  /* NEW: $isDisabled for subtle dim */
  display: grid !important;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1.5fr) !important;
  align-items: center !important;
  padding: 12px 20px !important;
  background: ${(p) => (p.$isSelected ? '#f9fffc' : '#ffffff')} !important;
  border-top: 1px solid #f0f4f2 !important;
  opacity: ${(p) => (p.$isDisabled ? 0.6 : 1)} !important; /* NEW: visual cue for disabled rows */
`;

/* base cell */
const ReviewTableCell = styled.div`
  font-size: 14px !important;
  color: #222 !important;
  min-height: 32px !important;
  display: flex !important;
  align-items: center !important;
  min-width: 0 !important; /* <-- crucial for grid shrink */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  margin-left: 3px !important;
`;

/* text-only cells need truncation */
const TextCell = styled(ReviewTableCell)`
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
`;

const ClientCell = styled(ReviewTableCell)`
  gap: 8px !important;
  min-width: 0 !important; /* let checkbox+label shrink */
  .label {
    min-width: 0 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    display: inline-block !important; /* ensure ellipsis works */
  }
`;

const SelectionCheckbox = styled(Checkbox)`
  .label {
    padding-left: 8px !important;
    font-size: 14px !important;
  }
`;

const ReviewSelect = styled(Select)`
  width: 100% !important;
  .select {
    width: 100% !important;
    border: 1px solid #d6e6db !important;
    border-radius: 6px !important;
    padding: 6px 32px 6px 12px !important;
    font-size: 14px !important;
    color: #1f3c2e !important;
    background-color: #ffffff !important;
  }
`;

const ReviewModalActions = styled(ModalActionsE)`
  justify-content: space-between !important;
  padding: 16px 24px !important;
  margin-left: auto !important;
  border-top: none !important;
`;

const ModalActionsGroup = styled.div`
  display: flex !important;
  gap: 12px !important;
`;

const CancelImportButton = styled(Button)`
  background-color: transparent !important;
  color: #1f3c2e !important;
  border: 1px solid #ccd9d1 !important;
  border-radius: 8px !important;
  padding: 10px 18px !important;
  box-shadow: none !important;
  &:hover {
    background-color: #f0f4f2 !important;
  }
`;

const ImportButton = styled(Button)`
  background-color: #3b97b1 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 10px 20px !important;
  box-shadow: none !important;
  &:hover,
  &:focus {
    background-color: #31839a !important;
  }
  &:disabled,
  &[uiDisabled='true'] {
    background-color: #bcd3da !important;
    cursor: not-allowed !important;
  }
`;

const BillingHeader = styled.div`
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
`;

const TooltipText = styled.div`
  max-width: 280px !important;
  font-size: 12px !important;
  line-height: 1.4 !important;
  color: #ffffff !important;
`;

const InfoIconWrapper = styled.span`
  display: inline-flex !important;
  width: 18px !important;
  height: 18px !important;
  svg {
    width: 18px !important;
    height: 18px !important;
  }
`;

export class Clients extends PureComponent<ClientsProps & DispatchProp & ClientsModalProps, State> {
  private selectAllCheckboxRef = React.createRef<HTMLInputElement>();
  constructor(props: ClientsProps & DispatchProp & ClientsModalProps) {
    super(props);
    this.handleCheckModal = this.handleCheckModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  public state: State = {
    isAddClientModalOpen: false,
    includeInactive: false,
    clients: [],
    sort: { column: 'displayName', value: 'ASC' },
    isPopModalRequired: false,
    isPopUpChecked: false,
    isPopUpModalOpen: true,
    showModal: '',
    isLoading: false,
    spinner: false,
    customers: [],
    dotMenu: {
      rowId: 0,
      active: false,
    },
    client: null,
    addSubClient: false,
    openDropdown: false,
    selectedCustomerIds: new Set<string>(),
    billingTypeSelections: {},
    billToSelections: {},
    isClientReviewModalVisible: false,
    customersLoading: false,
    customerFetchError: null,

    // NEW: init maps
    parentById: {},
    childrenById: {},
    showSuccessModal: false,
    accountCanSeePricing: readCachedPricingPermission(false),
  };

  public setFocusFirstFieldOnClientModal: any;

  public async componentDidMount(): Promise<void> {
    // Track View with Mixpanel
    trackView(MixpanelEvents.CLIENTS, {});
    // End of code for Track View with Mixpanel

    document.addEventListener('mousedown', this.handleClickOutsideDotMenu);
    document.addEventListener('touchstart', this.handleClickOutsideDotMenu);

    const { accountId } = this.props;
    const showModal = localStorage.getItem('showModal');
    this.setState({ showModal: showModal, isLoading: true });

    try {
      if (accountId) {
        const res = await getAccount(accountId);

        if (res && res.isModalOpen)
          this.setState({
            isPopUpModalOpen: res.isModalOpen,
            accountCanSeePricing: !!res.canSeePricing,
          });
        else if (res) {
          this.setState({
            accountCanSeePricing: !!res.canSeePricing,
          });
        }
      }
    } catch (error) {
      console.log(error);
      this.setState({ isLoading: false });
    }
    try {
      await checkIsBilling(accountId);
      await createCrispProfile(accountId);
      const profile = await getCrispProfile(accountId);

      if (profile) {
        Crisp.user.setEmail(profile.email);
        Crisp.user.setNickname(`${profile.person.nickname}`);
      }
    } catch (error) {
      console.error('An error occurred during component mounting:', error);
      this.setState({ isLoading: false });
    } finally {
      await this.loadClients();
      this.setState({ isLoading: false });
    }
  }

  public componentWillUnmount(): void {
    document.removeEventListener('mousedown', this.handleClickOutsideDotMenu);
    document.removeEventListener('touchstart', this.handleClickOutsideDotMenu);
  }

  public handleShowDotMenu = (data: any) => {
    this.setState((prev) => {
      return {
        ...prev,
        dotMenu: {
          rowId: data.id,
          active: prev.dotMenu.rowId !== data.id ? true : !prev.dotMenu.active,
        },
      };
    });
  };

  public openDropdown = () => {
    this.setState((prev) => ({
      ...prev,
      openDropdown: true,
    }));
  };

  public handleClickOutsideDotMenu = (e: Event) => {
    const target = e.target as HTMLElement;

    if (!target.closest('.client_table_cell') && !target.closest('.dots_menu')) {
      this.setState((prev) => {
        const isMenuClosed = prev.dotMenu.rowId === 0 && !prev.dotMenu.active && !prev.openDropdown;

        if (isMenuClosed) {
          return null;
        }

        return {
          dotMenu: { rowId: 0, active: false },
          openDropdown: false,
        };
      });
    }
  };

  public handleDotMenuAction = async (action: string, client: any) => {
    const { accountId } = this.props;
    const clientId = client.id || 0;
    switch (action) {
      case 'view':
        if (client?.id) {
          // Track lastViewedAt for project
          await handleUpdateLastViewedProject(client?.id)
        }
        // add session storage query for the opening client more details on client page
        sessionStorage.setItem('openDetails', 'true');
        location.href = `/clients/${client.id}`;

        this.setState((prev) => ({ ...prev, dotMenu: { rowId: 0, active: false } }));
        break;
      case 'edit':
        // fetch the client for edit modal
        const res_edit = await getClientApi({ clientId, accountId });
        if (res_edit.error) {
          console.log('An error has occured during fetch Client');
          return;
        }

        this.setState((prev) => {
          return {
            ...prev,
            isAddClientModalOpen: true,
            client: res_edit,
            dotMenu: {
              rowId: 0,
              active: false,
            },
          };
        });
        break;
      case 'add_sub_client':
        // fetch the client for adding subclient modal
        const res_add_sub_client = await getClientApi({ clientId, accountId });
        if (res_add_sub_client.error) {
          console.log('An error has occured during fetch Client');
          return;
        }

        this.setState((prev) => {
          return {
            ...prev,
            isAddClientModalOpen: true,
            client: res_add_sub_client,
            addSubClient: true,
            dotMenu: {
              rowId: 0,
              active: false,
            },
          };
        });
        break;
      default:
        this.setState((prev) => {
          return {
            ...prev,
            isAddClientModalOpen: false,
            client: null,
            addSubClient: false,
            dotMenu: {
              rowId: 0,
              active: false,
            },
          };
        });
        break;
    }
  };

  //QBO Import Clients

  public clickImportClients = async () => {
    const { history } = this.props;
    if (!this.props.isConnected) {
      history.push('quickbooks_connect');
      return;
    }

    this.setState({
      spinner: true,
      customersLoading: true,
      customerFetchError: null,
      isClientReviewModalVisible: true,
      showSuccessModal: false,
    });
    try {
      const response = await fetchQBOCustomers(this.props.accountId);
      const customers =
        response && Array.isArray(response.customerData)
          ? (response.customerData as QuickbooksCustomer[])
          : [];
      this.hydrateCustomers(customers);

      this.setState({ customersLoading: false, customerFetchError: null, spinner: false });
    } catch (fetchError) {
      this.setState({ customersLoading: false, spinner: false });
      console.error('Error fetching QuickBooks clients:', fetchError);
      this.handleCustomersFetchError(
        'We could not load your QuickBooks clients. Please try again.'
      );
    }
  };

  private getCustomerId(customer: QuickbooksCustomer): string | null {
    if (customer && customer.Id != null) {
      return String(customer.Id);
    }
    return null;
  }

  private deriveBillingType(customer: QuickbooksCustomer): BillingTypeOption {
    return customer && customer.Taxable ? 'Retail' : 'Trade';
  }

  private deriveBillTo(customer: QuickbooksCustomer): BillToOption {
    return customer && customer.BillWithParent ? 'Parent' : 'Self';
  }

  private stripImportQueryParam() {
    if (
      typeof window === 'undefined' ||
      !window.history ||
      typeof window.history.replaceState !== 'function'
    ) {
      return;
    }
    const url = new URL(window.location.href);
    if (!url.searchParams.get('importClients')) {
      return;
    }
    url.searchParams.delete('importClients');
    const next = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState({}, document.title, next);
  }

  private updateSelectAllCheckboxState() {
    const ref = this.selectAllCheckboxRef.current;
    if (!ref) {
      return;
    }
    const total = this.state.customers.length;
    const selected = this.state.selectedCustomerIds.size;
    ref.indeterminate = selected > 0 && selected < total;
  }

  private getSelectedCount(): number {
    return this.state.selectedCustomerIds.size;
  }

  private getParentLabel(
    customer: QuickbooksCustomer,
    customersById: Map<string, QuickbooksCustomer>
  ): string {
    const parentId = customer.ParentRef && customer.ParentRef.value;
    if (!parentId) {
      return 'N/A';
    }
    const parent = customersById.get(String(parentId));
    return (
      (parent && parent.DisplayName) || (customer.ParentRef && customer.ParentRef.name) || 'N/A'
    );
  }

  // NEW: build parent/children maps from flat list
  private buildHierarchy(customers: QuickbooksCustomer[]) {
    const parentById: Record<string, string | null> = {};
    const childrenById: Record<string, string[]> = {};

    customers.forEach((c) => {
      const id = this.getCustomerId(c);
      if (!id) return;
      const p = c.ParentRef && c.ParentRef.value ? String(c.ParentRef.value) : null;
      parentById[id] = p;
      if (p) {
        if (!childrenById[p]) childrenById[p] = [];
        childrenById[p].push(id);
      }
      if (!childrenById[id]) childrenById[id] = []; // ensure key exists
    });

    return { parentById, childrenById };
  }

  // NEW: collect ALL descendants (recursive)
  private getDescendants(id: string): string[] {
    const out: string[] = [];
    const stack = [...(this.state.childrenById[id] || [])];
    while (stack.length) {
      const cur = stack.pop()!;
      out.push(cur);
      const kids = this.state.childrenById[cur] || [];
      for (const k of kids) stack.push(k);
    }
    return out;
  }

  // NEW: check if ALL ancestors are selected
  private hasAllAncestorsSelected(
    id: string,
    selected: Set<string> = this.state.selectedCustomerIds
  ): boolean {
    let parent = this.state.parentById[id] || null;
    while (parent) {
      if (!selected.has(parent)) return false;
      parent = this.state.parentById[parent] || null;
    }
    return true;
  }

  private hydrateCustomers(customers: QuickbooksCustomer[]) {
    const ids: string[] = [];
    const billingTypeSelections: Record<string, BillingTypeOption> = {};
    const billToSelections: Record<string, BillToOption> = {};

    customers.forEach((customer) => {
      const id = this.getCustomerId(customer);
      if (!id) {
        return;
      }
      ids.push(id);
      billingTypeSelections[id] = this.deriveBillingType(customer);
      billToSelections[id] = this.deriveBillTo(customer);
    });

    const { parentById, childrenById } = this.buildHierarchy(customers); // NEW
    this.setState(
      {
        customers,
        selectedCustomerIds: new Set<string>(ids),
        billingTypeSelections,
        billToSelections,
        isClientReviewModalVisible: customers.length > 0,
        customersLoading: false,
        customerFetchError: null,
        parentById, // NEW
        childrenById, // NEW
        showSuccessModal: customers.length === 0,
      },
      () => {
        this.updateSelectAllCheckboxState();
        this.stripImportQueryParam();
      }
    );
  }

  private handleCustomersFetchError(message: string) {
    this.setState(
      {
        customersLoading: false,
        customerFetchError: message,
        isClientReviewModalVisible: true,
        showSuccessModal: false,
        parentById: {}, // NEW: reset maps
        childrenById: {}, // NEW: reset maps
      },
      () => {
        this.updateSelectAllCheckboxState();
        this.stripImportQueryParam();
      }
    );
  }

  @Bind()
  private handleSelectAllToggle() {
    this.setState((prevState) => {
      const allIds = prevState.customers
        .map((customer) => this.getCustomerId(customer))
        .filter((id): id is string => Boolean(id));
      if (prevState.selectedCustomerIds.size === allIds.length) {
        return { selectedCustomerIds: new Set<string>() };
      }
      // Selecting all selects parents and children together; rule is satisfied.
      return { selectedCustomerIds: new Set<string>(allIds) };
    }, this.updateSelectAllCheckboxState);
  }

  @Bind()
  private handleCustomerToggle(customerId: string) {
    this.setState((prevState) => {
      const next = new Set(prevState.selectedCustomerIds);
      const isSelected = next.has(customerId);

      if (!isSelected) {
        // Trying to select; only allow if all ancestors are selected
        if (!this.hasAllAncestorsSelected(customerId, next)) {
          // Block selection when parent chain not selected
          return { selectedCustomerIds: next };
        }
        next.add(customerId);
      } else {
        // Deselect this id AND all its descendants
        next.delete(customerId);
        const descendants = this.getDescendants(customerId);
        for (const id of descendants) next.delete(id);
      }

      return { selectedCustomerIds: next };
    }, this.updateSelectAllCheckboxState);
  }

  @Bind()
  private handleBillingTypeChange(customerId: string, value: BillingTypeOption) {
    this.setState((prevState) => ({
      billingTypeSelections: { ...prevState.billingTypeSelections, [customerId]: value },
    }));
  }

  @Bind()
  private handleBillToChange(customerId: string, value: BillToOption) {
    this.setState((prevState) => ({
      billToSelections: { ...prevState.billToSelections, [customerId]: value },
    }));
  }

  @Bind()
  private async handleImportSelected() {
    const { accountId } = this.props;
    const { selectedCustomerIds, customers, billingTypeSelections, billToSelections } = this.state;

    const selectedIds = Array.from(selectedCustomerIds);
    if (selectedIds.length === 0) return;

    // index customers for quick lookup
    const byId = new Map<string, QuickbooksCustomer>();
    for (const c of customers) {
      const id = this.getCustomerId(c);
      if (id) byId.set(id, c);
    }

    const toBoolTaxable = (billing: BillingTypeOption | undefined) =>
      (billing || 'Retail') === 'Retail';
    const toBoolBillWithParent = (billTo: BillToOption | undefined) =>
      (billTo || 'Self') === 'Parent';

    type Mapped = {
      qbId: string;
      displayName?: string;
      parentQbId: string | null;
      job: boolean;
      taxable: boolean;
      billWithParent: boolean;
      billingType: BillingTypeOption;
      billToParent: 0 | 1;
    };

    // Build the mapped payload once
    const mappedAll: Mapped[] = selectedIds
      .map((id) => {
        const qb = byId.get(id);
        if (!qb) return null;

        const billing = billingTypeSelections[id] || this.deriveBillingType(qb);
        const billTo = billToSelections[id] || this.deriveBillTo(qb);

        return {
          qbId: id,
          displayName: qb.DisplayName,
          parentQbId: (qb && qb.ParentRef && qb.ParentRef.value) || null,
          job: Boolean(qb.Job),
          taxable: toBoolTaxable(billing),
          billWithParent: toBoolBillWithParent(billTo),
          billingType: billing,
          billToParent: billTo === 'Self' ? 0 : 1,
        };
      })
      .filter(Boolean) as Mapped[];

    // --- batching helpers ---
    const chunk = <T,>(arr: T[], size: number) => {
      const out: T[][] = [];
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    };

    // simple concurrency limiter (no deps)
    const runPool = async <T,>(tasks: (() => Promise<T>)[], concurrency: number) => {
      const results: T[] = [];
      let i = 0;
      const workers = Array(Math.min(concurrency, tasks.length))
        .fill(0)
        .map(async () => {
          while (i < tasks.length) {
            const cur = i++;
            results[cur] = await tasks[cur]();
          }
        });
      await Promise.all(workers);
      return results;
    };

    // backoff fetch wrapper
    const callImport = async (body: any, maxRetries = 3) => {
      let attempt = 0;
      // If your importQBOClients is a wrapper around fetch/axios, use it; otherwise:
      // return await importQBOClients(accountId, body.customersData, body.mappedCustomers);
      while (true) {
        try {
          return await importQBOClients(accountId, body.customersData, body.mappedCustomers);
        } catch (err) {
          attempt++;
          const status = (err && err.response && err.response.status) || (err && err.status) || 0;

          const retryable = status === 0 || status === 429 || (status >= 500 && status < 600);
          if (!retryable || attempt > maxRetries) throw err;
          const delay = Math.min(2000 * 2 ** (attempt - 1), 8000) + Math.random() * 300;
          await new Promise((r) => setTimeout(r, delay));
        }
      }
    };

    // build batches of mapped selections
    const BATCH_SIZE = 100;
    const batches = chunk(mappedAll, BATCH_SIZE);

    // progress
    let insertedTotal = 0,
      skippedTotal = 0,
      updatedTotal = 0;

    this.setState({ spinner: true });

    try {
      trackView(MixpanelEvents.QB_CONNECT, {
        action: 'confirm_import_review',
        accountId,
        selectedClients: mappedAll.length,
        batches: batches.length,
        batchSize: BATCH_SIZE,
      });

      const tasks = batches.map((mappedBatch, idx) => async () => {
        // send only the needed customers for this batch
        const qbIds = new Set(mappedBatch.map((m) => m.qbId));
        const customersSubset = [...qbIds]
          .map((id) => byId.get(id))
          .filter(Boolean) as QuickbooksCustomer[];

        const result = await callImport({
          customersData: customersSubset,
          mappedCustomers: mappedBatch,
        });

        insertedTotal += (result && result.customerData && result.customerData.inserted) || 0;
        updatedTotal += (result && result.customerData && result.customerData.updated) || 0;
        skippedTotal += (result && result.customerData && result.customerData.skipped) || 0;

        trackView(MixpanelEvents.QB_CONNECT, {
          action: 'import_batch_done',
          accountId,
          batchIndex: idx,
          batchSize: mappedBatch.length,
          inserted: (result && result.customerData && result.customerData.inserted) || 0,
          updated: (result && result.customerData && result.customerData.updated) || 0,
          skipped: (result && result.customerData && result.customerData.skipped) || 0,
        });

        return result;
      });

      // Run with limited parallelism
      const MAX_CONCURRENCY = 3;
      await runPool(tasks, MAX_CONCURRENCY);
      await this.loadClients();
      this.setState({
        isClientReviewModalVisible: false,
        spinner: false,
      });

      trackView(MixpanelEvents.QB_CONNECT, {
        action: 'import_all_done',
        accountId,
        clients_number: insertedTotal,
        updatedTotal,
        skippedTotal,
        batches: batches.length,
      });
    } catch (err) {
      console.error('Import clients failed', err);
      this.setState({ spinner: false });
      trackView(MixpanelEvents.QB_CONNECT, {
        action: 'import_clients_failed',
        accountId,
        error: String((err && err.message) || err),
      });
    }
  }

  private renderClientsReviewModal(): React.ReactNode {
    const {
      isClientReviewModalVisible,
      customers,
      customersLoading,
      customerFetchError,
      billingTypeSelections,
      billToSelections,
    } = this.state;

    if (!isClientReviewModalVisible) {
      return null;
    }

    const total = customers.length;
    const selectedCount = this.getSelectedCount();
    const clientColumnTitle = selectedCount > 0 ? `${selectedCount} selected` : '0 selected';

    const customersById = new Map<string, QuickbooksCustomer>();
    customers.forEach((customer) => {
      const id = this.getCustomerId(customer);
      if (id) {
        customersById.set(id, customer);
      }
    });

    return (
      <div data-qa="clients-review-modal">
        <ReviewModal
          uiActive={isClientReviewModalVisible}
          uiOnRequestClose={() => this.setState({})}
        >
        <ReviewModalHeader>{`${total} Client${
          total === 1 ? '' : 's'
        } are ready to be imported`}</ReviewModalHeader>

        <ReviewModalContent>
          <ReviewSummaryHeading>
            <br />{' '}
          </ReviewSummaryHeading>
          {customersLoading ? (
            <div>Loading clients from QuickBooks...</div>
          ) : customerFetchError ? (
            <div>{customerFetchError}</div>
          ) : (
            <ReviewTable>
              <ReviewTableHeader>
                <div className="flex items-center gap-2">
                  <input
                    name="markAll"
                    type="checkbox"
                    className={`checkbox ${selectedCount !== total ? 'minus' : ''}`}
                    checked={selectedCount > 0}
                    onChange={this.handleSelectAllToggle}
                  />
                  <span>{clientColumnTitle}</span>
                </div>
                <span>Sub-Client of</span>
                <BillingHeader>
                  <span>Billing Type</span>
                  <Tooltip
                    overlay={
                      <TooltipText>
                        We treat tax exempt clients as Trade and non tax exempt as Retail. Please
                        update as needed for your business.
                      </TooltipText>
                    }
                    placement="top"
                    overlayClassName="qb-billing-tooltip"
                  >
                    <InfoIconWrapper>
                      <InfoIcon />
                    </InfoIconWrapper>
                  </Tooltip>
                </BillingHeader>
                <span>Bill to</span>
              </ReviewTableHeader>

              {customers.map((customer) => {
                const id = this.getCustomerId(customer);
                if (!id) {
                  return null;
                }
                const isSelected = this.state.selectedCustomerIds.has(id);

                // NEW: child can be selected only if all ancestors selected
                const enabledByParent = this.hasAllAncestorsSelected(id);

                const billingValue = billingTypeSelections[id] || this.deriveBillingType(customer);
                const billToValue = billToSelections[id] || this.deriveBillTo(customer);
                return (
                  <ReviewTableRow key={id} $isSelected={isSelected} $isDisabled={!enabledByParent}>
                    <ClientCell>
                      <SelectionCheckbox
                        checked={isSelected}
                        onChange={() => this.handleCustomerToggle(id)}
                        title={
                          enabledByParent
                            ? customer.DisplayName || 'QuickBooks Client'
                            : 'Select the parent first'
                        }
                        disabled={!enabledByParent} /* NEW */
                        uiDisabled={!enabledByParent} /* NEW: for UI lib parity */
                      >
                        <TextCell title={customer.DisplayName}>
                          {customer.DisplayName || 'QuickBooks Client'}
                        </TextCell>
                      </SelectionCheckbox>
                    </ClientCell>

                    <TextCell title={this.getParentLabel(customer, customersById)}>
                      {this.getParentLabel(customer, customersById)}
                    </TextCell>

                    <ReviewTableCell>
                      <ReviewSelect
                        value={billingValue}
                        onChange={(event) =>
                          this.handleBillingTypeChange(id, event.target.value as BillingTypeOption)
                        }
                        data-qa="clients-import-billing-type"
                      >
                        {BILLING_TYPE_OPTIONS.map((option) => (
                          <option
                            key={option}
                            value={option}
                            data-qa={`clients-import-billing-type-${option.toLowerCase()}`}
                          >
                            {option}
                          </option>
                        ))}
                      </ReviewSelect>
                    </ReviewTableCell>
                    <ReviewTableCell>
                      <ReviewSelect
                        value={billToValue}
                        onChange={(event) =>
                          this.handleBillToChange(id, event.target.value as BillToOption)
                        }
                        disabled={!customer || !customer.ParentRef || !customer.ParentRef.value}
                        data-qa="clients-import-bill-to"
                      >
                        {BILL_TO_OPTIONS.map((option) => (
                          <option
                            key={option}
                            value={option}
                            data-qa={`clients-import-bill-to-${option.toLowerCase()}`}
                          >
                            {option}
                          </option>
                        ))}
                      </ReviewSelect>
                    </ReviewTableCell>
                  </ReviewTableRow>
                );
              })}
            </ReviewTable>
          )}
        </ReviewModalContent>
        <ReviewModalActions>
          <ModalActionsGroup>
            <CancelImportButton
              onClick={() => this.setState({ isClientReviewModalVisible: false })}
            >
              Cancel
            </CancelImportButton>
          </ModalActionsGroup>
          <ModalActionsGroup>
            <ImportButton onClick={this.handleImportSelected} uiDisabled={selectedCount === 0}>
              {selectedCount === total && total > 0
                ? 'Import All'
                : `Import ${selectedCount} client${selectedCount === 1 ? '' : 's'}`}
            </ImportButton>
          </ModalActionsGroup>
        </ReviewModalActions>
        </ReviewModal>
      </div>
    );
  }

  public render(): JSX.Element {
    const reviewModal = this.renderClientsReviewModal();
    /* tslint:disable:jsx-alignment */
    return (
      <PageContent className="clients-page-content" data-qa="clients-page">
        {this.state.spinner && (
          <DuplicateSpinner
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
            data-qa="clients-export-loader"
          >
            <FadeLoader
              style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 9999,
              }}
              color="#3B97B1"
              aria-label="Loading Spinner"
              data-testid="export-loader"
            />
          </DuplicateSpinner>
        )}
        {window.location.pathname === '/clients' && (
          <div data-qa="clients-header">
            <Header
              headingText="Clients"
              addButtonText="Add New Client"
              inactiveFilter={this.state.includeInactive}
              onSearch={this.handleSearch}
              onInactiveFilterChange={this.toggleInactiveFilter}
              onAddClick={this.showAddClientModal}
              onItemClick={this.selectClient}
              showDropdown
              openDropdown={this.openDropdown}
              dropdownState={this.state.openDropdown}
              clickImportClients={this.clickImportClients}
              showAddButton={this.state.accountCanSeePricing}
            />
          </div>
        )}

        <div data-qa="clients-success-modal">
          <SuccessModal
            open={this.state.showSuccessModal}
            onClose={() => this.setState({ showSuccessModal: false })}
          />
        </div>
        {reviewModal}
        <ContentSection>
          <Switch>
            <Route
              path="/clients/:id"
              render={(props) => (
                <div data-qa="clients-client-container">
                  <ClientContainer
                    key={props.match.params.id}
                    clientId={parseInt(props.match.params.id, 10)}
                    onClose={this.closeClient}
                    onOtherClientChoosed={this.selectClient}
                    onClientChanged={this.onClientChanged}
                    gotoDraperyOrder={this.gotoDraperyOrder}
                    list={this.state.clients}
                    handleOpenSubscriptionPlanModal={this.props.handleOpenSubscriptionPlanModal}
                    isConnected={this.props.isConnected}
                    handleShowBottomSheet={this.props.handleShowBottomSheet}
                    handlePreFill={this.props.handlePreFill}
                    handleOpenSinglePurchasedGoods={this.props.handleOpenSinglePurchasedGoods}
                    purchasedGoodsRefetch={this.props.purchasedGoodsRefetch}
                    accountUser={this.props.accountUser}
                    canAccessTeamSettings={this.props.canAccessTeamSettings}
                    handleUpdateTeamMembers={this.props.handleUpdateTeamMembers}
                    backToTop={this.props.backToTop}
                    pageScrollTo={this.props.pageScrollTo}
                    {...props}
                  />
                </div>
              )}
            />
            <Route
              path="/clients"
              render={() => (
                <div data-qa="clients-table">
                  <ClientsTable
                    key={this.state.clients.toString()}
                    sort={this.state.sort}
                    onSortingChanged={this.handleSortingChange}
                    list={this.state.clients}
                    scrollTop={this.state.scrollTop}
                    onRowChoosed={this.selectClient}
                    isLoading={this.state.isLoading}
                    onSearch={this.handleSearch}
                    onItemClick={this.selectClient}
                    handleShowDotMenu={this.handleShowDotMenu}
                    handleDotMenuAction={this.handleDotMenuAction}
                    dotMenu={this.state.dotMenu}
                  />
                </div>
              )}
            />
          </Switch>
          <div data-qa="clients-client-modal">
            <ClientModal
              client={this.state.client}
              isModalOpen={this.state.isAddClientModalOpen || this.props.isOpenModal}
              onModalClose={this.closeAddClientModal}
              onClientSaved={this.onClientChanged}
              resetOnClose
              setFocusFirstField={(fn) => (this.setFocusFirstFieldOnClientModal = fn)}
              addSubClient={this.state.addSubClient}
            />
          </div>
          {!this.state.isPopUpModalOpen && (
            <div data-qa="clients-popups-required-modal">
              <ConfirmationModal
                uiActive={this.state.showModal === 'true'}
                uiAcceptLabel="Ok"
                uiHeader="Pop-ups Required"
                uiDeclineLabel={false}
                uiOnConfirm={this.handleCloseModal}
                uiOnClose={() => {}}
                uiOnRequestClose={() => {}}
                uiCloseOnOutsideClick={true}
                uiCloseOnEsc={true}
                className="pop-up"
                footerClassName="justify-end"
              >
                <p>
                  QUIPA utilizes pop-ups. Please ensure pop-ups are enabled for{' '}
                  <a href="https://my.quipa.com/">my.quipa.com </a>
                  in your browser settings.
                </p>

                <Checkbox checked={this.state.isPopUpChecked} onClick={this.handleCheckModal}>
                  {' '}
                  <span
                    style={{
                      fontSize: '14px',
                      position: 'relative',
                      bottom: '1px',
                    }}
                  >
                    Do not show this message again
                  </span>
                </Checkbox>
              </ConfirmationModal>
            </div>
          )}
        </ContentSection>
      </PageContent>
    );
  }

  private closeAddClientModal = () => {
    this.setState({
      isAddClientModalOpen: false,
      client: null,
      dotMenu: {
        rowId: 0,
        active: false,
      },
      addSubClient: false,
    });
    this.props.handleCloseModal();
  };

  private showAddClientModal = () => {
    this.setState(
      {
        isAddClientModalOpen: true,
      },
      () => {
        if (this.setFocusFirstFieldOnClientModal) {
          this.setFocusFirstFieldOnClientModal();
        }
      }
    );
  };

  private closeClient = () => {
    const { history } = this.props;
    history.push('/clients');
  };

  private selectClient = async (id: number, scrollTop?: number) => {
    if (id) {
      // Track lastViewedAt for project
      await handleUpdateLastViewedProject(id)
    }
    this.setState({ scrollTop });
    const { history } = this.props;
    history.push(`/clients/${id === 0 ? '' : id}`);
  };

  private handleSearch: HeaderProps['onSearch'] = async (search) => {
    const { accountId } = this.props;
    const { includeInactive } = this.state;
    const res = await searchClients({
      text: search,
      accountId,
      includeInactive,
    });
    if (res.error) {
      return [];
    }
    return res.map((r: BasicClientInfo) => ({
      id: r.id,
      displayName: r.displayName,
      parentName: r.parent && r.parent.displayName,
    }));
  };

  private toggleInactiveFilter = (includeInactive: boolean) => {
    this.setState(
      {
        includeInactive,
      },
      () => {
        this.loadClients();
      }
    );
  };

  private onClientChanged = (client: ClientModule.BasicClientInfo) => {
    // need here to just append state with new client
    // if parentId is 0 or not set just append to the general list
    // if parentId is set, need to find the parent client in the clist list (can be possible sub-client) and append it here
    // for now just reload clients
    // if (!parentId) {
    //     this.setState({
    //         clients: [
    //             ...this.state.clients,
    //             client,
    //         ],
    //     });
    // }
    this.loadClients();
  };

  private handleSortingChange = (sort: 'ASC' | 'DESC', key: string) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        sort: {
          ...prevState.sort,
          column: key,
          value: sort,
        },
      }),
      () => this.loadClients()
    );
  };

  public async loadClients(): Promise<void> {
    const { accountId } = this.props;
    const { includeInactive } = this.state;
    const res = await getAllClients({
      accountId,
      sort: { column: this.state.sort.column, value: this.state.sort.value },
      // sort: "ASC",
      includeInactive,
    });
    if (!res.error) {
      const convertToSortTableRowInfo = (client: ClientModule.BasicClientInfo) => {
        const rowInfo: SortTableRowInfo = client;
        if (client.subClients) {
          rowInfo.subList = client.subClients.map(convertToSortTableRowInfo);
        }
        return rowInfo;
      };

      this.setState({
        clients: res.map(convertToSortTableRowInfo),
      });
    }
  }

  private gotoDraperyOrder = (
    clientId: number | undefined,
    draperyOrderId?: number,
    clientDisplayName?: string,
    tab?: 'summary',
    customOrderType?: string | null
  ) => {
    const { history } = this.props;
    let draperyItem: any = localStorage.getItem('draperyItem');
    if (draperyItem) {
      draperyItem = JSON.parse(draperyItem);
    } else {
      draperyItem = {};
    }
    draperyItem.from = location.pathname;

    let romanShadeItem: any = localStorage.getItem('romanShadeItem');
    if (romanShadeItem) {
      romanShadeItem = JSON.parse(romanShadeItem);
    } else {
      romanShadeItem = {};
    }
    romanShadeItem.from = location.pathname;

    localStorage.setItem('draperyItem', JSON.stringify(draperyItem));
    localStorage.setItem('romanShadeItem', JSON.stringify(romanShadeItem));

    history.push(
      `/calculator${customOrderType ? `?type=${customOrderType}` : '?type=drapery-order'}`,
      {
        clientId,
        draperyOrderId,
        clientDisplayName,
        tab,
        type: customOrderType ? customOrderType : 'drapery-order',
      }
    );
  };
  private handleCheckModal() {
    this.setState({ isPopUpChecked: !this.state.isPopUpChecked });
  }

  private async handleCloseModal() {
    const { accountId } = this.props;

    const res = await updateAccount({
      accountId: accountId,
      isModalOpen: this.state.isPopUpChecked,
    });

    if (res.error) {
      throw new Error(res.message);
    }
    localStorage.setItem('showModal', 'false');
    const showModal = localStorage.getItem('showModal');
    this.setState({ showModal: showModal });
  }
}

function mapStateToProps(state: RootState, ownProps: ClientOwnProps): ClientsProps {
  const user = localStorage.getItem('quipa-store');
  const email = user ? JSON.parse(user).user.email : '';

  return {
    ...ownProps,
    accountId: parseFloat(localStorage.getItem('accountId') || '0'),
    email: email,
    firstName: localStorage.getItem('firstName') || '',
    lastName: localStorage.getItem('lastName') || '',
  };
}

export const ClientsContainer = connect(mapStateToProps)(Clients);
